import { type FC } from "react";

import { useAppContext } from "@/shared/hooks/useAppContext";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

import familyTriageIntro from "@/shared/assets/family-triage/family-triage-intro.svg";

export const AdminFamilyTriageIntroScreen: FC<FlowCustomComponentProps> = () => {
  const { person } = useAppContext();
  const name = person?.first_name ?? "the decedent";

  return (
    <div className="flex flex-col gap-6">
      <img
        src={familyTriageIntro}
        alt="People discussing family details"
        className="h-[260px] w-[260px]"
      />

      <div className="flex flex-col gap-1">
        <p className="font-sans text-xl font-semibold leading-[30px]">
          Confirm who the court needs to hear from
        </p>
        <p className="text-sm text-secondary tracking-[-0.28px]">
          Courthouse rules require a complete map of {name}'s legal heirs (distributees)
          before granting legal authority. Most of the list is pre-filled from official
          records, and confirming takes a few minutes.
        </p>
      </div>
    </div>
  );
};
